const pageNum = {
  state: {
    num: 1
  },

  mutations: {
    SET_PAGENUM: (state, item) => {
      state.num = item;
    }
  },

  actions: {}
};

export default pageNum;
